import { OnboardingProgress } from './OnboardingProgress';

const name = 'OnboardingProgress';

export { name, OnboardingProgress };
